import { Link } from '@inertiajs/react'
import Flash from '@/components/ui/Flash'

const ADMIN_NAV = [
  { href: '/admin', label: 'Overview' },
  { href: '/admin/episodes', label: 'Episodes' },
  { href: '/admin/series', label: 'Series' },
  { href: '/admin/tags', label: 'Tags' },
  { href: '/admin/users', label: 'Users' },
]

export function AdminSidebar({ active }: { active: string }) {
  return (
    <>
    <aside className="w-56 shrink-0 bg-white border-r border-gray-100 min-h-screen p-5">
      <p className="font-bold text-gray-900 mb-8">GetCasts Admin</p>
      <nav className="space-y-1">
        {ADMIN_NAV.map(l => (
          <Link
            key={l.href}
            href={l.href}
            className={`block px-3 py-2 rounded-lg text-sm transition-colors ${
              active === l.href
                ? 'bg-brand/10 text-brand font-semibold'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </aside>
    <Flash />
  </>
  )
}
